import Logger from 'core/utils/Logger'

export const parseJson = <T>(value: string): T | null => {
  let parsed = null
  try {
    parsed = JSON.parse(value)
  } catch (e: any) {
    Logger.error('fail to parse json', e, value)
  }
  return parsed
}
